module.exports = __webpack_public_path__ + "media/old_images/app-btn-google-play-b90dd2de.png";